var exports = {
  "iR": "RuleRowBetaLabelContainer__tK5Ut7",
  "Xe": "RuleRowBetaLabel__FmV0eX",
  "MF": "RuleRowErrorContainer__AWQME0",
  "gu": "RuleRowErrorInnerContainer__MkCeXu",
  "z1": "RuleRowToggleButton__O6NJU7",
  "mj": "RuleRowToggleButtonText__CY1BUL",
  "WZ": "settingsReadOnly__nWU2N4",
  "Uf": "settingsEditable__F1bTml",
  "t7": "toggleReadOnly__d3la4g",
  "R8": "toggleEditable__cFOQib",
  "Q0": "expandedReadOnly__4UoHxt",
  "QJ": "expandedEditable__UtzOGE",
};

module.exports = exports;
